import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Euro_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.85583 8.75C5.78653 9.15195 5.75 9.56971 5.75 10C5.75 10.4303 5.78653 10.848 5.85583 11.25H11C11.4142 11.25 11.75 11.5858 11.75 12C11.75 12.4142 11.4142 12.75 11 12.75H6.29226C7.17778 14.8547 9.04316 16.25 11.1012 16.25C12.3711 16.25 13.5495 15.732 14.4823 14.842C14.7819 14.556 15.2567 14.5672 15.5426 14.8669C15.8286 15.1666 15.8174 15.6413 15.5177 15.9272C14.3361 17.0547 12.7964 17.75 11.1012 17.75C8.11522 17.75 5.66499 15.6327 4.69629 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H4.33962C4.28059 10.8417 4.25 10.424 4.25 10C4.25 9.57603 4.28059 9.15833 4.33962 8.75H3C2.58579 8.75 2.25 8.41421 2.25 8C2.25 7.58579 2.58579 7.25 3 7.25H4.69629C5.66499 4.36729 8.11522 2.25 11.1012 2.25C12.7964 2.25 14.3361 2.94529 15.5177 4.07276C15.8174 4.3587 15.8286 4.83344 15.5426 5.13313C15.2567 5.43281 14.7819 5.44395 14.4823 5.15801C13.5495 4.26801 12.3711 3.75 11.1012 3.75C9.04316 3.75 7.17778 5.14529 6.29226 7.25H11C11.4142 7.25 11.75 7.58579 11.75 8C11.75 8.41421 11.4142 8.75 11 8.75H5.85583Z"
            />
        </SvgStyled>
    );
};

export default Euro_sm;
